import * as r from "react";
import { u as a } from "./index-CCKe-Mpx.js";
var s = r[" useId ".trim().toString()] || (() => {
}), i = 0;
function n(e) {
  const [t, o] = r.useState(s());
  return a(() => {
    o((u) => u ?? String(i++));
  }, [e]), t ? `radix-${t}` : "";
}
export {
  n as u
};
